import React, { useMemo } from "react";
import { useNavigate } from "react-router-dom";
import { IconArrowLeft, IconArrowRight } from "@tabler/icons-react";
import { useFirebaseDatabaseRootData } from "../../../context/FirebaseDatabaseRootDataContext";

const ProjectNavigation = ({ currentProjectId, onNavigate }) => {
  const navigate = useNavigate();
  const { rootData } = useFirebaseDatabaseRootData();
  const projects = useMemo(() => rootData?.projects || [], [rootData]);

  const currentIndex = projects.findIndex(p => p.id === currentProjectId);

  if (currentIndex === -1 || projects.length <= 1) {
    return null;
  }

  const nextProject = projects[(currentIndex + 1) % projects.length];
  const prevProject = projects[(currentIndex - 1 + projects.length) % projects.length];

  const handlePrevClick = () => {
    if (onNavigate) {
      onNavigate(prevProject);
    } else {
      navigate(`/project/${prevProject.id}`);
    }
  };

  const handleNextClick = () => {
    if (onNavigate) {
      onNavigate(nextProject);
    } else {
      navigate(`/project/${nextProject.id}`);
    }
  };

  return (
    <div className="project-navigation">
      <button className="nav-button prev" onClick={handlePrevClick}>
        <IconArrowLeft size={20} />
        <span>Previous Project</span>
      </button>
      <button className="nav-button next" onClick={handleNextClick}>
        <span>Next Project</span>
        <IconArrowRight size={20} />
      </button>
    </div>
  );
};

export default ProjectNavigation;
